module.exports = __webpack_public_path__ + "static/media/peanut-butter.afc809fe.png";